import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icon, ButtonIcon, TextInput, ButtonGroup, Switcher, Button, Checkbox, FileUploadV2, Modal, Notification, DataTable, Breadcrumb } from "pepsico-ds";
import { useEffect, useState } from "react";
import helpOutlineIcon from "../../assets/guest_invitation/help_outline.svg"
import "./entra-guest.css"
import entraGuestService from "./entra-guest.service";
import { toast, ToastContainer } from 'react-toastify';
import { useLoading } from "../../loader";
import axios from "axios";

const EntraGuestInvitationRequest = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { REACT_APP_API_ENDPOINT } = process.env;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [companyName, setCompanyName] = useState("");
    const [domain, setDomain] = useState("");
    const [domainError, setDomainError] = useState("");
    const [activeButtonIndex, setActiveButtonIndex] = useState(0);
    const [guestName, setGuestName] = useState("");
    const [guestEmail, setGuestEmail] = useState("");
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [guestDetailsArr, setGuestDetailsArr] = useState([{guestName: "", guestEmail: "", nameError: "", emailError: ""}]);
    const [isConfirmedOne, setIsConfirmedOne] = useState(false);
    const [isConfirmedTwo, setIsConfirmedTwo] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const {showLoader, hideLoader} = useLoading();
    const [firstNameError, setFirstNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));
    const [requestData, setRequestData] = useState(null);
    const [showValidationError, setShowValidationError] = useState(false);
    const [validationErrorCounts, setValidationErrorCounts] = useState({totalRow:0, valid: 0, invalid: 0, issues:0});
    const [validationErrorModalData, setValidationErrorModalData] = useState([]);
    const [showErrorModal, setErrorShowModal] = useState(false);
    const [isSubmitFailed, setIsSubmitFailed] = useState(false);
    const toTitleCase = (str) => {
        return str
        .toLowerCase()
        .trimStart()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    useEffect(()=>{
        const modifiedGuestDetailsArr = guestDetailsArr.map((rec)=>({...rec, guestName: toTitleCase(rec?.guestName), guestEmail: rec?.guestEmail?.trim()}));
        if (JSON.stringify(modifiedGuestDetailsArr) !== JSON.stringify(guestDetailsArr)) {
            setGuestDetailsArr(modifiedGuestDetailsArr);
        }
    },[guestDetailsArr])

    const resetFields = () => {
        setGuestDetailsArr([{guestName: "", guestEmail: "", nameError: "", emailError: ""}]);
        setIsConfirmedOne(false);
        setIsConfirmedTwo(false);
        setUploadedFiles([]);
        setShowValidationError(false);
        setValidationErrorCounts({totalRow:0, valid: 0, invalid: 0, issues:0});
        setValidationErrorModalData([]);
    }

    const handleSubmit = async() => {
        showLoader();
        try{
            if(selectedTabIndex === 0){
                const validatePayload = {
                    guestUsers: guestDetailsArr.map((rec)=>({guestName: rec?.guestName?.trim?.(), guestEmail: rec?.guestEmail, ...((rec?.hasOwnProperty("domain") && rec?.hasOwnProperty("companyName")) && {domain: rec?.domain, companyName: rec?.companyName})}))
                }

                const validateResponse = await entraGuestService.validateRequest(validatePayload);

                if(validateResponse?.guestValidation?.every?.((rec)=>rec?.valid && !rec?.errorMessage)){
                    const formData = new FormData();
                    formData.append("file", null);
                    const payload = {
                        requestType: "INLINE",
                        guestUsers: guestDetailsArr.map((rec)=>({guestName: rec?.guestName?.trim?.(), guestEmail: rec?.guestEmail, ...((rec?.hasOwnProperty("domain") && rec?.hasOwnProperty("companyName")) && {domain: rec?.domain, companyName: rec?.companyName})})),
                        isNdaAcknowledged: isConfirmedOne,
                        isExpiryConsentAccepted: isConfirmedTwo,
                    };
                    formData.append(
                        "request",
                        new Blob([JSON.stringify(payload)], { type: "application/json" })
                    );
                    const response = await entraGuestService.submitRequest(formData);
                    if (response?.responseStatus === 'Success' || response?.status === 'Success') {
                        hideLoader();
                        setShowModal(true);
                        setRequestData(response);
                    }
                    else {
                        hideLoader();
                        toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
                    }
                    resetFields()
                }else{
                    let updatedGuestDetailsArr = [...guestDetailsArr]
                    validateResponse?.guestValidation?.forEach((rec)=>{
                        if(!rec?.valid && rec?.errorMessage){
                            updatedGuestDetailsArr = updatedGuestDetailsArr.map((gd)=> (gd?.guestEmail?.toLowerCase?.() === rec?.guestEmail?.toLowerCase?.() && !gd?.nameError && !gd?.emailError && !gd?.domainError) ? {...gd, ...((rec?.errorMessage?.toLowerCase?.()?.includes("name") && !rec?.errorMessage?.toLowerCase?.()?.includes("mail")) ? {nameError: rec?.errorMessage} : (rec?.errorMessage?.toLowerCase?.()?.includes("domain")) ? {domainError: rec?.errorMessage} : {emailError: rec?.errorMessage}), ...((rec?.errorMessage?.toLowerCase?.()?.includes("domain")) && {domain: gd?.domain || "", companyName: gd?.companyName || ""})} : gd)
                        }
                    })
                    setGuestDetailsArr(updatedGuestDetailsArr)
                }
            }else{
                const formData = new FormData();
                formData.append("file", uploadedFiles[0]);
                const payload = {
                    requestType: "BULK",
                    guestUsers: [],
                    isNdaAcknowledged: isConfirmedOne,
                    isExpiryConsentAccepted: isConfirmedTwo,
                };
                formData.append(
                    "request",
                    new Blob([JSON.stringify(payload)], { type: "application/json" })
                );
                const response = await entraGuestService.submitRequest(formData);
                if (response?.responseStatus === 'Success' || response?.status === 'Success') {
                    hideLoader();
                    setShowModal(true);
                    setRequestData(response);
                    resetFields();
                }
                else if(response?.csvValidationResult){
                    const validationErrors = {...validationErrorCounts, 
                        totalRow: response?.csvValidationResult?.totalRows || 0, 
                        valid: response?.csvValidationResult?.validCount || 0, 
                        invalid: response?.csvValidationResult?.invalidCount || 0};
                    setValidationErrorCounts(validationErrors);
                    setValidationErrorModalData(response?.csvValidationResult?.invalidRows?.map?.((rec)=>({row: `Row Number ${rec?.rowNumber}`, message: rec?.errorMessage})))
                    setShowValidationError(true)
                    setIsSubmitFailed(true);
                }
                else {
                    hideLoader();
                    toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
                    resetFields();
                }
            }
        }catch (error) {
            hideLoader();
            toast.error(t("entraGuest.request_fail_message"),"error");
            resetFields();
        }finally{
            hideLoader();
        }
    }

    const disableSubmit = () => {
        return ((selectedTabIndex === 0 ? guestDetailsArr?.some((data)=>(data.hasOwnProperty("domain") && data.hasOwnProperty("companyName") ? (!data?.guestName || !data?.guestEmail || !data?.domain || !data?.companyName || data?.emailError || data?.nameError || data?.domainError) : (!data?.guestName || !data?.guestEmail || data?.emailError || data?.nameError))) : !(uploadedFiles.length && !isSubmitFailed)) || !isConfirmedOne || !isConfirmedTwo)
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const onClickCopynumber = () => {
        if (requestData?.requestNumber) {
            navigator.clipboard.writeText(requestData?.requestNumber?.toString?.()).then(() => {
                setCopyButtonText(t('nonArExtension.copied'));
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        }
    };

    const onViewRequest = () => {
        const statePayload = { type: "requestNumber", value: requestData?.requestNumber};
        navigate("/audit-requests", { state: statePayload });
    }

    const renderConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showModal}
                    className="entra-request-success-modal"
                    onCloseModal={closeModal}
                    closeOnOutsideClick = {false}
                    notificationsProps={{
                        secondaryActionLabel: (
                            <>
                                <Icon
                                    alt="alt value"
                                    icon={copyButtonText == t('nonArExtension.copied') ? "check" : "content_copy"}
                                    size="medium"
                                    style={{ marginRight: '6px', display: 'unset' }}
                                />

                                {copyButtonText}
                            </>
                        ),
                        secondaryActionOnClick: onClickCopynumber,
                        text: `${requestData?.requestNumber}`,
                        title: t('nonArExtension.request_number_title'),
                        type: 'info'
                    }}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={true}
                    primaryButtonProps={{
                        onClick: onViewRequest,
                        size: 'medium',
                        text: t('homePage.view_request'),
                        variant: 'primary'
                    }}
                    showSecondaryButton={false}
                    showSlot
                    showTertiaryButton={true}
                    tertiaryButtonProps={{
                        onClick: closeModal,
                        size: 'medium',
                        text: t('nonArExtension.back'),
                        variant: 'tertiary'
                    }}
                    showCloseButton={true}
                    style={{}}
                    text={<>
                        <div style={{ marginTop: '10px'}}>
                        <p  className="modal-para-text">{t('entraGuest.entra_request_confirmation_text')} 
                        </p>
                        </div>
                    </>}
                    title={t('entraGuest.entra_request_confirmation_title')}
                    type="fluid"
                    viewPort={`${isMobile ? "mobile" : "desktop"}`}
                >
                    <p style={{fontSize:'16px'}} className="modal-para-text">{`${t('entraGuest.see_all_your_requests_in_the')} `} <span className="view-request-txt">{`${t('entraGuest.view_request')} `}</span> {t('entraGuest.section_below')} 
                    </p>
                </Modal>
            </div>
        )
    }

    const validationErrorColumns = [
      { columnKey: "row", header: t("idx.row"), showColumnVisibility: true, initialSize: 140 },
      { columnKey: "message", header: t("idx.message"), showColumnVisibility: true, initialSize: 360 },
    ];

    const renderValidationErrorModal = () => {
        return (
            <div className="validation-error-modal">
                <Modal
                    size="large"
                    id=""
                    className={isMobile ? "mobile-view-request-modal hide-rows-per-page validation-error-modal" : "validation-error-modal hide-rows-per-page"}
                    closeOnOutsideClick = {false}
                    onCloseModal={()=>setErrorShowModal(false)}
                    showCloseButton
                    showModal={showErrorModal}
                    style={{}}
                    tertiaryButtonProps=""
                    showAuxiliaryButton={false}
                    showPrimaryButton={false}
                    showSecondaryButton={false}
                    title={`${t("idx.showing")} ${validationErrorCounts?.invalid} ${t("idx.issues")}`}
                    type="fluid"
                >
                    <DataTable
                        className="datatable"
                        columns={validationErrorColumns}
                        key={i18n.language}
                        enableSorting={true}
                        data={validationErrorModalData}
                        pageIndex={0}
                        pageSize={10}
                        selection="single"
                        tableHeader=""
                        size="large"
                        showTableHeader={true}
                        showTitle={true}
                        showSearchOption={false}
                        showColumnFilters={false}
                        showDescription={false}
                        tableDescription=""
                        showPagination={true}
                        noDataDescriptionText=""
                    />
                </Modal>
            </div>
        )
    }

    return(
        <>
            <div className="entra-guest-main-container">
                <div
                    className={isMobile ? "row" : "container"}
                    style={{
                        background: "none",
                        boxShadow: "none",
                        justifyContent: isMobile ? "center" : "",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            flexDirection: isMobile ? "column" : "row",
                            gap: isMobile ? "0px" : "15px",
                            flexWrap: "wrap",
                            flex: 1,
                        }}
                    >
                        <div className={isMobile ? "row mt-2" : ""} style={{ justifyContent: isMobile ? "center" : "" }}>
                            {/* <div className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : 'd-flex mb-0'}  align-items-center ad-main-heading-container`} style={{ gap: "12px" }}>
                                <ButtonIcon
                                    className=""
                                    color="Interaction/Active"
                                    icon="arrow_backward"
                                    label="Label"
                                    onClick={()=>navigate(-1)}
                                    size="medium"
                                    style={{}}
                                    type="default"
                                />
                                <div className="d-flex flex-column">
                                    <div className="ad-main-heading">{t("entraGuest.m365_guest_invitation_request")}</div>
                                    <div className="ad-main-desc">{t("entraGuest.m365_guest_invitation_request_desc")}</div>
                                </div>
                            </div> */}
                             <div
                                className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : ''} ad-main-heading-container`}
                            >
                                <Breadcrumb
                                    homeIcon={{
                                        icon: "home",
                                        onClick:()=>{
                                        navigate("/home")
                                        }
                                    }}
                                    breadcrumbs={[
                                        {
                                            label: "Home",
                                        },
                                        {
                                            label: "M365 Guest Invitation Request",
                                        },
                                    ]}
                                    className="entra-breadcrumb"
                                    useAnchor
                                />

                                <div className="ad-page-header">
                                    <div className="ad-main-heading">
                                        {t("entraGuest.m365_guest_invitation_request")}
                                    </div>

                                    <div className="ad-main-desc">
                                        {t("entraGuest.m365_guest_invitation_request_desc")}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card-layout reg-card mb-3 mb-md-0 active-directory-card-container entra-guest-container"
                                style={{
                                    flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                                    width: isMobile ? "100%" : "auto",
                                    flexDirection: isMobile ? "column" : "row",
                                    gap: "1rem"
                                }}
                            >
                                <div style={{...(!isMobile && { flex: "2" })}}>
                                    <div className="card card-content align-items-center">
                                        <>
                                            <div className="multiple-guest-tab">
                                                <Switcher
                                                    className=""
                                                    items={[
                                                        {
                                                            label: t("entraGuest.add_manually"),
                                                            leadingIcon: 'add',
                                                            showLeadingIcon: true,
                                                            
                                                        },
                                                        {
                                                            label: t("entraGuest.bulk_upload"),
                                                            leadingIcon: 'upload',
                                                            showLeadingIcon: true
                                                        }
                                                    ]}
                                                    selectedItemIndex={selectedTabIndex}
                                                    onUpdate={(n)=>setSelectedTabIndex(n)}
                                                    size="medium"
                                                    style={{}}
                                                    variant="default"
                                                />
                                            </div>
                                            {
                                                selectedTabIndex === 0 ?
                                                <div className="guest-list-container">
                                                    <Notification
                                                        className="mb-3"
                                                        primaryActionOnClick={function w8e(){}}
                                                        secondaryActionOnClick={function w8e(){}}
                                                        showActionButtons={false}
                                                        showIcon
                                                        showText={false}
                                                        showTitle
                                                        style={{}}
                                                        title={t("entraGuest.maximum_of_5_records_can_be_added")}
                                                        type="info"
                                                    />
                                                    { guestDetailsArr?.map?.((guest,i)=>{
                                                        const currentGuestEmail = guestDetailsArr[i]?.guestEmail;
                                                        const currentGuestName = guestDetailsArr[i]?.guestName;
                                                        const isShowEmailError =  currentGuestEmail?.length > 0 && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentGuestEmail) || currentGuestEmail?.length > 75) || (currentGuestName?.length > 0 && (/[^A-Za-z ]/.test(currentGuestName))) || guest?.emailError || guest?.nameError || guest?.domainError;
                                                        return <div className="guest-detail">
                                                            <div className="guest-detail-fields">
                                                                <div className="guest-detail-label mb-2">{`${t("entraGuest.guest")} ${i+1}`}</div>
                                                                <div className="row">
                                                                    <div className={isMobile ? "col-12" : "col-12 col-md-6 mb-3"}>
                                                                        <TextInput
                                                                            name="guestName"
                                                                            type="text"
                                                                            value={guest.guestName}
                                                                            placeholderText={t("entraGuest.guest_name")}
                                                                            error={guest?.nameError}
                                                                            maxLength={100}
                                                                            onChange={(e) => {
                                                                                const guestDetail = {...guest};
                                                                                if(/[^A-Za-z ]/.test(e.target.value)) {
                                                                                    guestDetail.nameError = t("updateProfile.alphabetError");
                                                                                }
                                                                                else if(guestDetail.guestName) {
                                                                                    guestDetail.nameError = "";
                                                                                }
                                                                                const newGuestDetailsArr = guestDetailsArr.map((g,index)=> (index===i ? {...guestDetail, guestName: e.target.value} : g))
                                                                                setGuestDetailsArr(newGuestDetailsArr);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className={isMobile ? "col-12" : "col-12 col-md-6 mb-3"}>
                                                                        <TextInput
                                                                            name="guestEmail"
                                                                            type="text"
                                                                            value={guest.guestEmail}
                                                                            placeholderText={t("entraGuest.guest_email")}
                                                                            error={guest?.emailError}
                                                                            onChange={(e) => {
                                                                                const guestDetail = {...guest};
                                                                                if(e.target.value?.length > 0 && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value?.trim?.()) || e.target.value?.length > 75)) {
                                                                                    guestDetail.emailError = t("entraGuest.guest_email_error");
                                                                                }
                                                                                else if(guestDetail.guestEmail || e.target.value?.length == 0) {
                                                                                    guestDetail.emailError = "";
                                                                                }
                                                                                const newGuestDetailsArr = guestDetailsArr.map((g,index)=> (index===i ? {...guestDetail, guestEmail: e.target.value} : g))
                                                                                setGuestDetailsArr(newGuestDetailsArr);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {
                                                                    guest.hasOwnProperty("domain") && guest.hasOwnProperty("companyName") ?
                                                                    <div className="row">
                                                                        <div className={isMobile ? "col-12" : "col-12 col-md-6 mb-3"}>
                                                                            <TextInput
                                                                                name="domain"
                                                                                type="text"
                                                                                value={guest.domain}
                                                                                placeholderText={t("entraGuest.domain")}
                                                                                error={guest?.domainError}
                                                                                onChange={(e) => {
                                                                                    const guestDetail = {...guest};
                                                                                    if(guestDetail?.nameError || guestDetail?.emailError || guestDetail?.domainError){
                                                                                        guestDetail.nameError = "";
                                                                                        guestDetail.emailError = "";
                                                                                        guestDetail.domainError = "";
                                                                                    }
                                                                                    // if(/[^A-Za-z ]/.test(e.target.value)) {
                                                                                    //     guestDetail.nameError = t("updateProfile.alphabetError");
                                                                                    // }
                                                                                    // else if(guestDetail.guestName) {
                                                                                    //     guestDetail.nameError = "";
                                                                                    // }
                                                                                    const newGuestDetailsArr = guestDetailsArr.map((g,index)=> (index===i ? {...guestDetail, domain: e.target.value} : g))
                                                                                    setGuestDetailsArr(newGuestDetailsArr);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className={isMobile ? "col-12" : "col-12 col-md-6 mb-3"}>
                                                                            <TextInput
                                                                                name="companyName"
                                                                                type="text"
                                                                                value={guest.companyName}
                                                                                placeholderText={t("entraGuest.company_name")}
                                                                                // error={guest?.emailError}
                                                                                onChange={(e) => {
                                                                                    const guestDetail = {...guest};
                                                                                    if(guestDetail?.nameError || guestDetail?.emailError || guestDetail?.domainError){
                                                                                        guestDetail.nameError = "";
                                                                                        guestDetail.emailError = "";
                                                                                        guestDetail.domainError = "";
                                                                                    }
                                                                                    // if(e.target.value?.length > 0 && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value) || e.target.value?.length > 75)) {
                                                                                    //     guestDetail.emailError = t("entraGuest.guest_email_error");
                                                                                    // }
                                                                                    // else if(guestDetail.guestEmail || e.target.value?.length == 0) {
                                                                                    //     guestDetail.emailError = "";
                                                                                    // }
                                                                                    const newGuestDetailsArr = guestDetailsArr.map((g,index)=> (index===i ? {...guestDetail, companyName: e.target.value} : g))
                                                                                    setGuestDetailsArr(newGuestDetailsArr);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                            </div>
                                                            <div className={`guest-detail-delete-button ml-3 d-flex ${isShowEmailError ? 'mb-5' : 'mb-3'}`}>
                                                                <ButtonIcon
                                                                    className={`${isShowEmailError ? '' : 'mb-1'}`}
                                                                    color="Interaction/Active"
                                                                    icon="delete"
                                                                    label="Label"
                                                                    onClick={()=>{
                                                                        const newGuestDetailsArr = guestDetailsArr.filter((g,index)=> i!==index )
                                                                        setGuestDetailsArr(newGuestDetailsArr);
                                                                    }}
                                                                    size="medium"
                                                                    style={{}}
                                                                    type="default"
                                                                    disabled={guestDetailsArr.length<2}
                                                                />
                                                            </div>
                                                        </div>
                                                    })
                                                    }
                                                    <Button
                                                        className="add-another-guest"
                                                        size="large"
                                                        onClick={() => setGuestDetailsArr([...guestDetailsArr,{guestName: "", guestEmail: "",  nameError: "", emailError: ""}])}
                                                        text={t("entraGuest.add_another_guest")}
                                                        variant="tertiary"
                                                        iconLeading="add"
                                                        disabled={guestDetailsArr.length>=5}
                                                    />
                                                </div> 
                                            :
                                                <div className="bulk-upload-section">
                                                    <div className="download-template-section">
                                                        <div className="download-template-label">
                                                            <Icon
                                                                alt="alt value"
                                                                icon="download"
                                                                size="18px"
                                                                className=""
                                                            />
                                                            <div className="d-flex flex-column text-left">
                                                                <div className="download-template-heading">{t("entraGuest.download_the_excel_template")}</div>
                                                                <div className="download-template-desc">{t("entraGuest.download_the_excel_template_desc")}</div>
                                                            </div>
                                                        </div>
                                                        <Button
                                                            className=""
                                                            loadingText=""
                                                            size="large"
                                                            style={{}}
                                                            text={t("entraGuest.download")}
                                                            variant="primary"
                                                            onClick={async()=>{
                                                                try {
                                                                const response = await axios.get(REACT_APP_API_ENDPOINT + "entra/downloadBulkTemplate", {
                                                                    responseType: "blob",
                                                                });
                                
                                                                const blob = new Blob([response.data], { type: "text/csv" });
                                                                const url = window.URL.createObjectURL(blob);
                                
                                                                const link = document.createElement("a");
                                                                link.href = url;
                                                                link.setAttribute("download", "bulk_request.csv");
                                                                document.body.appendChild(link);
                                                                link.click();
                                
                                                                link.parentNode.removeChild(link);
                                                                window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                console.error("Error downloading the file:", error);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <FileUploadV2
                                                        accept=".csv"
                                                        buttonLabel="Upload file"
                                                        description={t("entraGuest.file_upload_desc")}
                                                        label={t("entraGuest.upload_filled_template")}
                                                        type="default"
                                                        uploadIcon="cloud_upload"
                                                        uploadedFilesLabel={t("entraGuest.uploaded_files")}
                                                        variant="complete"
                                                        isShowUploadedFileCount={false}
                                                        helperText={t("entraGuest.maximum_of_50_records_per_bulk_upload")}
                                                        files={uploadedFiles}
                                                        disabled={uploadedFiles.length>0}
                                                        onUpdate={(files)=>{
                                                            setUploadedFiles([files]);
                                                            if(isSubmitFailed) setIsSubmitFailed(false);
                                                            if(showValidationError){
                                                                setShowValidationError(false);
                                                                setValidationErrorModalData([]);
                                                                setValidationErrorCounts({totalRow:0, valid: 0, blankRow: 0, issues:0});
                                                            }
                                                        }}
                                                        onDelete={(i)=>{
                                                            const filteredUploadedFiles = uploadedFiles.filter((f,index)=> i !==index )
                                                            setUploadedFiles(filteredUploadedFiles);
                                                            if(isSubmitFailed) setIsSubmitFailed(false);
                                                            if(showValidationError){
                                                                setShowValidationError(false);
                                                                setValidationErrorModalData([]);
                                                                setValidationErrorCounts({totalRow:0, valid: 0, blankRow: 0, issues:0});
                                                            }
                                                        }}
                                                        multiple={false}
                                                        required={true}
                                                    />
                                                    {
                                                        showValidationError ?
                                                        <div className="idx-validation-error-section">
                                                            <Icon
                                                                alt="alt value"
                                                                icon="error"
                                                                size="18px"
                                                                className="main-icon"
                                                            />
                                                            <div className="idx-validation-error-main-section">
                                                                <div className="error-heading mb-2">{t("idx.validation_failed")}</div>
                                                                <div className="error-desc mb-2">{t("idx.validation_failed_desc")}</div>
                                                                <div className="error-tags-section">
                                                                    <div className="total-row-tag">
                                                                        <Icon
                                                                            alt="alt value"
                                                                            icon="table_rows"
                                                                            size="18px"
                                                                            className=""
                                                                        />
                                                                        <div>{`${validationErrorCounts?.totalRow} ${t("idx.total_rows")}`}</div>
                                                                    </div>
                                                                    <div className="valid-tag">
                                                                        <Icon
                                                                            alt="alt value"
                                                                            icon="check"
                                                                            size="18px"
                                                                            className=""
                                                                        />
                                                                        <div>{`${validationErrorCounts?.valid} ${t("idx.valid")}`}</div>
                                                                    </div>
                                                                    <div className="blank-row-tag">
                                                                        <Icon
                                                                            alt="alt value"
                                                                            icon="border_clear"
                                                                            size="18px"
                                                                            className=""
                                                                        />
                                                                        <div>{`${validationErrorCounts?.invalid} ${t("idx.invalid")}`}</div>
                                                                    </div>
                                                                    {/* <div className="issues-tag">
                                                                        <Icon
                                                                            alt="alt value"
                                                                            icon="error"
                                                                            size="18px"
                                                                            className=""
                                                                        />
                                                                        <div>{`${validationErrorCounts?.issues} ${t("idx.issues")}`}</div>
                                                                    </div> */}
                                                                    <div className="show-issues-tag" disabled={!validationErrorModalData.length} onClick={()=>setErrorShowModal(true)}>{t("idx.show_issues")}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : null
                                                    }
                                                </div>
                                            }
                                        </>
                                        {/* } */}
                                        <div className="row px-3 acknowledge-text-first-row">
                                            <Checkbox
                                                className=""
                                                feedbackType="info"
                                                helperText=""
                                                size="small"
                                                style={{}}
                                                checked ={isConfirmedOne}
                                                onUpdate={(event) => {
                                                setIsConfirmedOne(event);
                                                }}
                                                text={t("entraGuest.acknowledge_text")}
                                            />
                                        </div>
                                        <div className="row px-3">
                                            <Checkbox
                                                className=""
                                                feedbackType="info"
                                                helperText=""
                                                size="small"
                                                style={{}}
                                                checked ={isConfirmedTwo}
                                                onUpdate={(event) => {
                                                setIsConfirmedTwo(event);
                                                }}
                                                text={t("entraGuest.acknowledge_text2")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{...(!isMobile && { flex: "1" })}}>
                                    <div className="card card-content align-items-center m-0 mb-3">
                                        <div className="ad-table-header help-section align-items-center d-flex mb-3" style={{ gap: "8px" }}>
                                            <ButtonIcon
                                                className=""
                                                color="Interaction/Active"
                                                icon="help_outline"
                                                label="Label"
                                                onClick={function wRe() { }}
                                                size="medium"
                                                type="default"
                                                style={{ cursor: "default"}}
                                            />
                                            <div className="help-page-text">{t("entraGuest.help_page")}</div>
                                        </div>
                                        <div className="help-section-link" onClick={()=>{
                                            window.open("https://www.mypepsico.com/mypepsico?id=kb_article&sysparm_article=KB0170638", "_blank", "noopener noreferrer");
                                        }}>
                                            <span>{t("entraGuest.m365_O365_guest_sharing")}</span>
                                            <Icon
                                                alt="alt value"
                                                icon="open_in_new"
                                                size="18px"
                                                className=""
                                            />
                                        </div>
                                    </div>
                                    <div className="card card-content align-items-center m-0">
                                        <div className="ad-table-header help-section source-icon align-items-center d-flex mb-3" style={{ gap: "8px" }}>
                                            <ButtonIcon
                                                className=""
                                                color="Interaction/Active"
                                                icon="source"
                                                label="Label"
                                                onClick={function wRe() { }}
                                                size="medium"
                                                type="default"
                                                style={{ cursor: "default"}}
                                            />
                                            <div className="help-page-text">{t("entraGuest.non_disclosure_agreement")}</div>
                                        </div>
                                        <div className="non-disclosure-text">{t("entraGuest.non_disclosure_agreement_desc")}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="entra-guest-footer mt-3">
                <div className="row footer-row-with-footer-buttons">
                    <div className="footer-buttons">
                        <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
                            <Button
                            className="search-user-cancel-button mr-md-2 my-0"
                            type="button"
                            size="medium"
                            text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
                            variant="tertiary"
                            onClick={()=>{}}
                            />
                        </div>
                        <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
                            <Button
                            className="search-user-select-button request-button my-0 px-3 justify-content-center"
                            type="button"
                            size="medium"
                            text={t("nonArExtension.submit")}
                            variant="primary"
                            onClick={handleSubmit}
                            disabled={disableSubmit()}
                            />
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="bottom-center"
                />
                {showModal && renderConfirmModal()}
                {showErrorModal && renderValidationErrorModal()}
            </div>
        </>
    )
}

export default EntraGuestInvitationRequest